'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reduxConnect = require('redux-connect');

var _components = require('components');

var _GroupForm = require('./GroupForm');

var _GroupForm2 = _interopRequireDefault(_GroupForm);

var _reactI18next = require('react-i18next');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Groups = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(contactsActions.loadGroups()).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, contactsActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Groups, _Component);

  function Groups() {
    (0, _classCallCheck3.default)(this, Groups);
    return (0, _possibleConstructorReturn3.default)(this, (Groups.__proto__ || (0, _getPrototypeOf2.default)(Groups)).apply(this, arguments));
  }

  (0, _createClass3.default)(Groups, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Groups' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Groups')
          ),
          _react2.default.createElement(
            'div',
            { className: 'row wide-border' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-60 col-md-30 col-md-push-30 margin-bottom-20' },
              _react2.default.createElement(_components.ManageLink, {
                className: 'section',
                link: '/contacts',
                header: t('Manage contacts'),
                isBack: true,
                text: t('Click here to create and manage your recipients contacts')
              }),
              _react2.default.createElement(
                'h3',
                null,
                t('Create new group')
              ),
              _react2.default.createElement(_GroupForm2.default, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-60 col-md-30 col-md-pull-30' },
              _react2.default.createElement(_components.GroupsList, null)
            )
          )
        )
      );
    }
  }]);
  return Groups;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = Groups;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Groups/Groups.js
// module id = 2153
// module chunks = 1